import { action, observable, makeObservable } from "mobx";
import { MrbBaseViewStore } from "mrb/core/stores";
import { MrbModalParams } from "mrb/common/models";
import { contentModes } from "common/constants";

class ActivateTrialViewStore extends MrbBaseViewStore {
    @observable isSubmitDisabled = false;
    @observable.ref subscriptionPlan = null;
    planId = null;
    @observable selectedContentModeOption = { value: contentModes.nakiStandard };

    contentModeOptions = [
        { value: contentModes.nakiStandard, label: "The Naki Standard" },
        { value: contentModes.whitelistMode, label: "Whitelist Mode" },
        { value: contentModes.certified, label: "Certified" },
    ];

    constructor(rootStore, { routeStore }) {
        super(rootStore);
        makeObservable(this);
        this.routeStore = routeStore;
        this.planId = rootStore.routerStore.routerState.params.planId;
        this.setContentModeOption(this.rootStore.premiumSubscriptionStore.enabledContentMode, false);
        this.contentModeInfoModal = new MrbModalParams(null, null);

        this.trialActivatedModal = new MrbModalParams(
            {
                onClose: this.redirectToMySubscription,
            },
            {
                onClickExplorePremium: this.goToPremiumContent,
            }
        );
    }

    @action.bound
    setContentModeOption(value, updateModeContentMode = true) {
        this.selectedContentModeOption.value = value;
        if (updateModeContentMode) {
            this.routeStore.updateContentMode(value);
            this.rootStore.premiumSubscriptionStore.setContentMode(value);
        }
    }

    @action.bound
    redirectToMySubscription() {
        this.rootStore.routerStore.goTo("master.application.premium.info");
    }

    goToPremiumContent = () => {
        this.rootStore.routerStore.goTo("master.application.categories.stories", {
            isPremium: true,
        });
    };

    onInit() {
        return this.fetchSubscriptionPlan();
    }

    async fetchSubscriptionPlan() {
        try {
            const subscriptionPlan = await this.routeStore.getSubscriptionPlan(this.planId);
            this.setSubscriptionPlan(subscriptionPlan);
        } catch (err) {
            this.rootStore.notificationStore.error("Unexpected error occurred. Please contact the support team.", err);
        }
    }

    @action.bound
    setSubscriptionPlan(plan) {
        this.subscriptionPlan = plan;
    }

    @action.bound
    activateTrial() {
        this.rootStore.confirmDialogStore.showConfirm({
            message: "Start trial?",
            description: "You won't be charged for the evaluation period.",
            yesLabel: "Start",
            onConfirm: async () => {
                try {
                    this.setIsSubmitDisabled(true);
                    await this.rootStore.premiumSubscriptionStore.activateTrial(this.planId);
                    this.trialActivatedModal.open({
                        trialEndDate: this.rootStore.premiumSubscriptionStore.subscription.trialPeriod.trialEndDate,
                        subscriptionPlan: this.subscriptionPlan.name,
                        selectedContentModeOption: this.selectedContentModeOption,
                        contentModeOptions: this.contentModeOptions,
                        setContentModeOption: this.setContentModeOption,
                        onClickContentModeInfo: this.contentModeInfoModal.open,
                    });
                } catch (err) {
                    this.rootStore.notificationStore.error(
                        "Unexpected error occurred while trying to activate trial period. Please contact the support team.",
                        err
                    );
                } finally {
                    this.setIsSubmitDisabled(false);
                }
            },
        });
    }

    @action.bound
    setIsSubmitDisabled(value) {
        this.isSubmitDisabled = value;
    }
}

export default ActivateTrialViewStore;
